import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as scheduledTasks from '../requests/scheduled-tasks-upcoming-req';
import {
  selectScheduledTasksCount,
  selectScheduledTasks,
  selectScheduledTasksPagination,
  selectScheduledTasksPaginationSending,
} from '../selectors';

function* loadMoreScheduledTasks({ payload }) {
  const paginationSending = yield select(selectScheduledTasksPaginationSending);
  const pagination = yield select(selectScheduledTasksPagination);
  const counter = yield select(selectScheduledTasksCount);
  const list = yield select(selectScheduledTasks);
  const listSize = size(list);

  if (counter <= listSize || paginationSending) {
    yield cancel();
  }

  yield put(
    scheduledTasks.paginationActions.send({
      ...payload,
      ...pagination,
      offset: listSize,
    }),
  );
}

export default function* scheduledTasksPagination() {
  yield takeLatest([scheduledTasks.consts.LOAD_MORE], loadMoreScheduledTasks);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/scheduled-tasks-pagination.js